export const numberToDollars = (
  value: number,
  locale = { region: 'en-US', currency: 'USD' },
  fractionDigits?: number
): string => {
  const formatter = new Intl.NumberFormat(locale.region, {
    style: 'currency',
    currency: locale.currency,
    minimumFractionDigits: fractionDigits !== undefined ? fractionDigits : 2,
    maximumFractionDigits: fractionDigits !== undefined ? fractionDigits : 2
  })
  return formatter.format(value)
}
